import { IsEmail, IsNotEmpty, ValidateIf } from 'class-validator';

export interface CreateTermIdentityRequest {
  consentLinkKey?: string;
  name: string;
  dateOfBirth: string;
  email?: string;
  line1?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export class IdentitySubmissionRequest {
  constructor(data?: Partial<IdentitySubmissionRequest>) {
    Object.assign(this, data);
  }
  consentLinkKey: string;
  @IsNotEmpty({ message: 'Name is required' })
  name: string;
  @IsNotEmpty({ message: 'Date of birth is required' })
  dateOfBirth: string;
  @ValidateIf(identity => identity.email)
  @IsEmail({}, { message: 'Email is not valid' })
  email: string;
  line1: string;
  city: string;
  state: string;
  zip: string;
}

export class TermResponseRequest {
  constructor(data?: Partial<TermResponseRequest>) {
    Object.assign(this, data);
  }

  @IsNotEmpty()
  termId: number;

  @IsNotEmpty({ message: 'A response is required' })
  consented: boolean;

  consentIdentityId?: string;
}

export class ConsentFormSubmissionRequest {
  constructor(data?: Partial<ConsentFormSubmissionRequest>) {
    Object.assign(this, data);
  }

  consentLinkKey?: string;

  consentIdentityId?: string;

  @IsNotEmpty()
  termId: number;

  @IsNotEmpty({ message: 'A response is required' })
  consented: boolean;
}

export interface ConsentLinkCreationRequest {
  userId: string;
}
